import "./PatientOptions.styles.scss";
import { Avatar } from "components";
import { components } from "react-select";
import React from "react";
import { useTranslation } from "react-i18next";
import {
  useOrganizationSettings,
  getPatientWordPlural,
} from "utils/hooks/organizations/useOrganizationSettings";

export const PatientOption = ({ showAvatar = false, ...props }) => {
  const { label, isSelected, isMulti } = props;
  return (
    <components.Option {...props}>
      <div className="patient-option">
        {isMulti && (
          <input type="checkbox" checked={isSelected} onChange={() => null} />
        )}{" "}
        {showAvatar && (
          <div className="patient-avatar-wrapper">
            <Avatar fullName={label} />
          </div>
        )}
        <p className="patient-option-label">{label}</p>
      </div>
    </components.Option>
  );
};

export const useAllPatientsOption = () => {
  const { t } = useTranslation(["common"]);
  const { settings: orgSettings } = useOrganizationSettings();

  return {
    label: t("common_labels.select_all_patients", {
      patientWordPlural: getPatientWordPlural(orgSettings),
    }),
    value: "*",
  };
};

export const ValueContainer = ({ children, ...props }) => {
  const currentValues = props.getValue();
  let toBeRendered = children;
  if (currentValues.some((val) => val.value === "*")) {
    toBeRendered = [[children[0][0]], children[1]];
  }

  return (
    <components.ValueContainer {...props}>
      {toBeRendered}
    </components.ValueContainer>
  );
};

export const MultiValue = (props) => {
  const { t } = useTranslation(["common"]);
  const { settings: orgSettings } = useOrganizationSettings();

  let labelToBeDisplayed = `${props.data.label}`;
  if (props.data.value === "*") {
    labelToBeDisplayed = t("common_labels.all_patients", {
      patientWordPlural: getPatientWordPlural(orgSettings),
    });
  }
  return (
    <components.MultiValue {...props}>
      <span>{labelToBeDisplayed}</span>
    </components.MultiValue>
  );
};
